import Link from 'next/link';
import styled from 'styled-components';

export const Wrapper = styled(Link)<{ $width: number; $height: number }>`
	display: inline-block;
	position: relative;
	z-index: 1000;
	width: ${p => p.$width}px;
	height: ${p => p.$height}px;
`;
